import React from 'react'
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

type Props = {
  isPublic?: boolean;
  outputType?: 'vtour' | 'ptcld';
}

const RedirectToViewer = ({ isPublic = false, outputType = 'vtour' }: Props) => {
  
  const { workspaceSlug, projectSlug, scanId } = useParams();
  const [searchParams] = useSearchParams();
  const hotspotId = searchParams.get("hotspotId");

  const path = `/${workspaceSlug}/${projectSlug}/${scanId}/viewer?type=${outputType}&mode=uniscan${hotspotId ? `&hotspotId=${hotspotId}` : ""}` 
  const navigateTo = isPublic ? `/public${path}` : path;

  return <Navigate to={navigateTo} />;
}

export default RedirectToViewer